import { AccessRightComponent } from './access-right/access-right.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Pipe, PipeTransform, APP_INITIALIZER } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppService } from '../app/services/app.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule, MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { JwtHelperService, JwtModule } from '@auth0/angular-jwt';
import { FileUploadModule } from 'ng2-file-upload';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';
import { NgbDateParserFormatter, NgbDateAdapter } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormat } from './model/ngb-date-parser-format';
import { NgbStringAdapter } from './model/ngb-date-string-adapter';
import { NgMultiSelectDropDownModule } from './other-component/multiselect-component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { RefreshTokenInterceptor } from '../app/services/token-interceptor.service';
import { MainNavComponent } from './main-nav/main-nav.component';
import { LayoutModule, MediaMatcher } from '@angular/cdk/layout';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { BulletinComponent } from './bulletin/bulletin.component';
import { BulletinEditComponent } from './bulletin/bulletin-edit/bulletin-edit.component';
import { MyProfileComponent } from './user-profile/my-profile/my-profile.component';
import { NgxLoadingModule } from './other-component/ngx-loading/public_api';
import { AngularDateTimePickerModule } from './other-component/angular2-datetimepicker';
import { RoleUsersComponent } from './role-users/role-users.component';
import { RoleUsersEditComponent } from './role-users/role-users-edit/role-users-edit.component';
import { ForbiddenComponent } from './forbidden/forbidden.component';
import { RoleComponent } from './role/role.component';
import { RoleEditComponent } from './role/role-edit/role-edit.component';
import { MenuComponent } from './menu/menu.component';
import { MenuEditComponent } from './menu/menu-edit/menu-edit.component';
import { UserProfileEditComponent } from './user-profile/user-profile-edit/user-profile-edit.component';
import { CommonModule } from '@angular/common';
import { environment } from 'projects/environments/environment';
import { SSOModuleModule } from 'projects/SSO/src/app/SSOModule/sso-module';
import { DialogConfirmComponent } from 'projects/Shared-Lib/component/dialog/dialog-confirm/dialog-confirm.component';
import { ToastConfirmComponent } from 'projects/Shared-Lib/component/dialog/toast-confirm/toast-confirm.component';
import { SharedLibModuleModule } from 'projects/Shared-Lib/component/shared-lib-module';
import { ResourceActionsComponent } from './resource-actions/resource-actions.component';
import { ResourceActionsEditComponent } from './resource-actions/resource-actions-edit/resource-actions-edit.component';
import { Menu } from './model/menu';
import { MenuActionsComponent } from './menu-actions/menu-actions.component';
import { AuthApplicationComponent } from './auth-application/auth-application.component';
import { AuthApplicationEditComponent } from './auth-application/auth-application-edit/auth-application-edit.component';
import { AuthUserComponent } from './auth-user/auth-user.component';
import { AuthUserEditComponent } from './auth-user/auth-user-edit/auth-user-edit.component';
import { AuthUserAppsComponent } from './auth-user-apps/auth-user-apps.component';
import { AuthUserAppsEditComponent } from './auth-user-apps/auth-user-apps-edit/auth-user-apps-edit.component';
import { MatExpansionModule } from "@angular/material/expansion";

export function tokenGetter() {
  return localStorage.getItem('access_token');
}

@Pipe({ name: 'safeHtml' })
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) { }
  transform(value) {
    console.log(`SafeHtmlPipe: ${this.sanitized.bypassSecurityTrustHtml(value)}`);
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}

export function InitApp(AppService: AppService) {
  return () => AppService.Init();
}

@NgModule({
  declarations: [
    AppComponent,
    BreadcrumbComponent,
    DashboardComponent,
    SidebarComponent,
    UserProfileComponent,
    DialogConfirmComponent,
    LoginComponent,
    HomeComponent,
    ToastConfirmComponent,
    UserProfileEditComponent,
    MainNavComponent,
    BulletinComponent,
    BulletinEditComponent,
    MyProfileComponent,
    ForbiddenComponent,
    RoleComponent,
    RoleEditComponent,
    RoleUsersComponent,
    RoleUsersEditComponent,
    SafeHtmlPipe,
    MenuComponent,
    MenuEditComponent,
    AccessRightComponent,
    ResourceActionsComponent,
    ResourceActionsEditComponent,
    MenuActionsComponent,
    AuthApplicationComponent,
    AuthApplicationEditComponent,
    AuthUserComponent,
    AuthUserEditComponent,
    AuthUserAppsComponent,
    AuthUserAppsEditComponent,
  ],
  bootstrap: [AppComponent],
  exports: [], imports: [SharedLibModuleModule,
    BrowserModule,
    AppRoutingModule,
    NgMultiSelectDropDownModule.forRoot(),
    NgbModule,
    MatTableModule,
    MatSortModule,
    MatCardModule,
    MatRippleModule,
    MatDialogModule,
    DragDropModule,
    FormsModule,
    NgSelectModule,
    CommonModule,
    AngularDateTimePickerModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({ maxOpened: 1 }),
    ReactiveFormsModule,
    FileUploadModule,
    JwtModule.forRoot({
      config: {
          tokenGetter: tokenGetter,
          allowedDomains: ['localhost:4200'],
      }
    }),
    MatSidenavModule,
    MatToolbarModule,
    MatIconModule,
    LayoutModule,
    MatButtonModule,
    MatListModule,
    MatCheckboxModule,
    MatRadioModule,
    NgxLoadingModule.forRoot({}),
    LoggerModule.forRoot({ serverLoggingUrl: '', level: environment.DebugLevel, serverLogLevel: NgxLoggerLevel.ERROR }),
    MatExpansionModule
],
  providers: [
      AppService,
      { provide: APP_INITIALIZER, useFactory: InitApp, deps: [AppService], multi: true },
      { provide: HTTP_INTERCEPTORS, useClass: RefreshTokenInterceptor, multi: true },
      { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: true } },
      JwtHelperService,
      MediaMatcher,
      { provide: NgbDateParserFormatter, useClass: NgbDateParserFormat },
      { provide: NgbDateAdapter, useClass: NgbStringAdapter },
      provideHttpClient(withInterceptorsFromDi())
    ]
})
export class AppModule {
}
